import _ from 'underscore';
import OptionTypes from 'app/backbone/helpers/OptionTypes';
import * as CellFactory from 'app/backbone/helpers/CellFactory';
import PeriodDaysTable from 'app/backbone/views/event/settings/accreditation/components/PeriodDaysTable.view';
import AvailableDayCell from './cells/AvailableDayCell.view';
import AvailableAllDaysCell from './cells/AvailableAllDaysCell.view';
import * as CompanyProfileItem from 'app/backbone/models/event/accreditation/companies/CompanyProfileItem';
import * as Period from 'app/backbone/models/event/settings/accreditation/Period';

export default class AvailableCompanyItemTable extends PeriodDaysTable {

    optionTypes() {
        return _.extend({}, super.optionTypes(), {
            collection: OptionTypes.instanceOf(CompanyProfileItem.Collection).isRequired,
            periods: OptionTypes.instanceOf(Period.Collection).isRequired,
            editing: OptionTypes.bool,
            placeholderHeight: OptionTypes.number
        });
    }

    optionDefaults() {
        return _.extend({}, super.optionDefaults(), {
            editing: true,
            placeholderHeight: 100
        });
    }

    initialize(options = {}) {
        this.resolveOptions(options);

        this.actions = this.initActions();
        this.placeholderText = this.getPlaceholderText();
        this.firstColumns = this.initFirstColumns();
        this.columns = this.initColumns();
        this.lastColumns = this.initLastColumns();
        super.initialize(options);
        this.stopListening(this.collection);
    }

    initFirstColumns() {
        return [{
            name: 'name',
            cell: 'string',
            label: 'Item',
            headerCell: CellFactory.createHeaderCell(),
            sortable: false,
            editable: false
        }, {
            name: 'all_days',
            label: 'All',
            cell: this.createAllDaysCell(this.periods.getAllDays()),
            headerCell: CellFactory.createHeaderCell('60px', 'center'),
            sortable: false,
            editable: false
        }];
    }

    initColumns() {
        return [];
    }

    initLastColumns() {
        const { actions } = this;
        return [{
            name: 'actions',
            label: 'Actions',
            cell: CellFactory.createActionCell(actions, null),
            sortable: false,
            editable: false
        }];
    }

    initActions() {
        return [{
            name: 'remove',
            icon: 'bs-icon-cross',
            tooltip: 'Remove item',
            action: this.removeItem.bind(this)
        }];
    }

    createDayCell(day, classNamePostfix) {
        const className = `${AvailableDayCell.prototype.className} ${classNamePostfix}`;
        return AvailableDayCell.extend({ day, className });
    }

    createAllDaysCell() {
        const { periods } = this;
        const days = periods.getAllDays();
        return AvailableAllDaysCell.extend({ days });
    }

    removeItem(item) {
        this.collection.remove(item);
    }

    getPlaceholderText() {
        return 'No items have been added for this profile. Add at least one.';
    }

}
